import { render } from "./CCQuery.vue?vue&type=template&id=672160aa&scoped=true"
import script from "./CCQuery.vue?vue&type=script&lang=js"
export * from "./CCQuery.vue?vue&type=script&lang=js"

import "./CCQuery.vue?vue&type=style&index=0&id=672160aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-672160aa"

export default script